//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular from 'angular';

import ExperienceContainerId from '@models/ExperienceContainerId';
import ExperiencesApiService from '@services/experiences-api-service';

export default class ExperiencesService {
  private experiencesSubject = null;

  constructor(
        private $q,
        private rx,
        private experiencesApiService: ExperiencesApiService,
    ) {
    this.experiencesSubject = new rx.ReplaySubject(1);
    this.refreshExperiences();
  }

  public getExperiences() {
    return this.experiencesSubject;
  }

  public deleteExperienceAsync(containerId: ExperienceContainerId) {
    return this.experiencesApiService.deleteExperienceAsync(containerId).then(() => {
      return this.refreshExperiences();
    });
  }

  public updateExperienceAsync(containerId: ExperienceContainerId, options: object) {
    return this.experiencesApiService.updateExperienceAsync(containerId, options).then(() => {
      return this.refreshExperiences();
    });
  }

  public refreshExperiences() {
    return this.experiencesApiService.getExperiencesAsync().then((experiencesResponse) => {
      this.experiencesSubject.next(experiencesResponse);
    });
  }

  public getExperiencesPromise() {
    return this.$q.when(this.experiencesSubject.take(1).toPromise());
  }
}

angular.module('curalate').service('ExperiencesService', [
  '$q',
  'rx',
  'ExperiencesApiService',
  ExperiencesService,
]);
